import { last } from 'lodash';
import moment from 'moment';
import { formatPhone } from 'utils/formatPhone';
const parseTime = (t: string) => {
  const [time, period] = t.split(' ');
  const [rawHour, minute] = time.split(':').map(Number);
  let hour = rawHour;

  if (period === 'PM' && hour !== 12) hour += 12;
  if (period === 'AM' && hour === 12) hour = 0;

  return hour * 60 + minute;
};
export const getTimeSections = (times: string[] = []) => {
  const sections = {
    morning: [] as string[],
    afternoon: [] as string[],
    evening: [] as string[]
  };
  times?.forEach(t => {
    const minutes = parseTime(t);
    if (minutes < 12 * 60) {
      sections.morning.push(t);
    } else if (minutes < 17 * 60) {
      sections.afternoon.push(t);
    } else {
      sections.evening.push(t);
    }
  });
  return sections;
};

/**
 * Whether a booking ending at `endTime` ('hh:mm A') runs past the latest available time slot of the day.
 * Returns false when there is nothing to compare against (no end time or no time slots loaded yet).
 */
export const isOverServiceHours = (endTime?: string, timeslots: string[] = []) => {
  const latestTimeSlot = last(timeslots);
  if (!endTime || !latestTimeSlot) return false;
  const endTimeMoment = moment(endTime, 'hh:mm A');
  const latestTimeMoment = moment(endTimeMoment.format('MM/DD/YYYY') + ' ' + latestTimeSlot, 'MM/DD/YYYY hh:mm A');
  return endTimeMoment > latestTimeMoment;
};

export const getOverServiceHoursMessage = (phone?: string) =>
  `The selected time falls outside our service hours. Please call in ${formatPhone(phone || '')} to schedule your appointment!`;
